/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  readMore: 'Read more',
  readLess: 'Read less'
})
